(function () {
    'use strict';

    if (!window.gsap || !window.ScrollTrigger) return;

    gsap.registerPlugin(ScrollTrigger);

    if (!window.Lenis || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const lenis = new Lenis();

    // Lenis garde le défilement natif mais l'amortit : ScrollTrigger doit être
    // prévenu à chaque pas, sinon ses calculs ont une image de retard.
    lenis.on('scroll', ScrollTrigger.update);

    // Une seule boucle d'animation pour les deux. lagSmoothing coupe le
    // rattrapage de GSAP, qui ferait sauter le défilement après un à-coup.
    gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    // Les blocs s'en servent pour défiler jusqu'à une position.
    window.bmgLenis = lenis;
})();
